import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Row, Col, Card, Tabs, Form, Checkbox, Button } from 'antd';

import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import { Action, CollectionServer, DropdownAction, GET, GetMetaProperties, JSXMap, POST, QueryDetail, QueryOrder, QueryParam, SetMetaProperties, deleteInArray, deleteInProperties, errorCatch, foreachInProperties, getObjectDisplay, uncapitalize, updateInArray } from 'fennec-ui'
import AbstractCollection from '../../../common/AbstractCollection';
import confirmKey from '../../components/ConfirmKeyModal';
import { Model } from 'fennec-ui';
import Icofont from 'react-icofont';
import PageLayout from '../../components/PageLayout';

import MDEditor, { commands, EditorContext } from "@uiw/react-md-editor";
import rehypeSanitize from "rehype-sanitize";
import { goTo } from '../../../common/Tool';
import User from '../../../common/User';


var _ = require('lodash');
const { TabPane } = Tabs;

var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.locale('ru');

function CRow({ auth, item, idx, object, modelActions, collection, setCollection }) {
    const [collapsed, setCollapsed] = useState(true);

    const rowColor = (false) ? "bg-red" : "bg-grey";

    return (<React.Fragment key={idx}>
        <tr key={idx} /*className={'pointer'} onClick={() => {
            setCollapsed(o => !o);
        }}*/>
            {/* <td className={`fill`}><div className={`bg ${rowColor}`} style={{ minWidth: "25px", maxWidth: "25px" }}>
                {(collapsed) && <i className="fa fa-plus-square-o"></i>}
                {(!collapsed) && <i className="fa fa-minus-square-o"></i>}
            </div></td> */}
            <td className={`fill`}>
                <div className={`bg ${rowColor}`} style={{ textAlign: "left" }}>
                    <div>{item?.name}</div>
                </div>
            </td>
            <td className={`fill`} onClick={(e) => { e.stopPropagation() }}>
                <DropdownAction
                    style={{ padding: "0" }}
                    button={() => (<div className={`bg ${rowColor} pointer`} style={{ minWidth: "25px", maxWidth: "25px", display: "flex", height: "100%", justifyContent: "center", alignItems: "center" }}>
                        <i className="fa fa-ellipsis-h"></i>
                    </div>)}
                    items={modelActions(item, idx)?.map((e, idx) => ({
                        key: e.key || idx,
                        auth: auth,
                        mode: "MenuItem",
                        object: item,
                        collection: collection,
                        setCollection: setCollection,
                        ...e
                    }))} />
            </td>
        </tr>
        {/* {(!collapsed) && <tr>
            <td colSpan={5} className={`fill`}>
                <div className="bg bg-orange" style={{ textAlign: "left", marginLeft: "25px" }}>
                    <div style={{ fontWeight: "300" }}>
                        {item?.name}
                    </div>
                </div>
            </td>
        </tr>} */}
    </React.Fragment>)
}

function RecalcEffectivnostForm(props) {

    const { auth, form, submit } = props;
    const [lock, setLock] = useState()

    useEffect(() => {
        let intervalID = setInterval(() => {
            GET(auth, "/api/query/resourcelocks?w-name=RecalcAllEffektivnostAndPredvzyatostSudei&detail=model", ({ data }) => {
                if (data?.length > 0) {
                    setLock(data[0])
                }
            }, errorCatch)
        }, 5000)
        return () => {
            if (intervalID) {
                clearInterval(intervalID)
            }
        }
    }, [])

    return (
        <div>
            {(!!lock) && <div style={{ flex: "auto" }}>
                <div style={{ fontWeight: "500" }}>
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                        {(lock.message) && <div style={{ fontSize: "13px", color: "rgba(0, 0, 0, 0.55)" }}>
                            Описание: {lock.message}
                        </div>}
                    </div>
                </div>
                <div style={{ fontWeight: "500" }}>
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <div style={{ fontSize: "13px", color: "rgba(0, 0, 0, 0.55)" }}>
                            Начало выполнения: {dayjs(lock.CreatedAt).format('DD.MM.YYYY HH:mm:ss')}
                        </div>
                    </div>
                </div>
                {(lock.progress) && <div style={{ fontSize: "13px", color: "rgba(0, 0, 0, 0.55)" }}>
                    Прогресс выполнения: {lock.progress}%
                </div>}
            </div>}
            <Form
                form={form}
                onFinish={submit}
                labelAlign={"left"}
                layout={"vertical"}
                initialValues={{
                    recalcAll: false
                }}
            >
                <Form.Item name="recalcAll" valuePropName="checked">
                    <Checkbox>
                        Перерассчитать все мероприятия, в том числе и рассчитанные
                    </Checkbox>
                </Form.Item>
            </Form>
        </div>
    )
}

export default function FederationadministratorSettingsDictionary(props) {
    const { auth } = props;

    const meta = useSelector(state => state.meta);

    const filtersFromMeta = React.useCallback((name) => {
        let prop = [];
        let p = _.get(meta[name], "properties");
        if (p) {
            prop = p?.filter(e => !_.get(e, "relation") || _.get(e, "relation.type") !== "one-many")?.map(e => ({ ...e, sort: true, filter: true, func: (e.filterType == "range") ? ["min", "max"] : undefined }))
        }
        return prop;
    }, [meta]);

    const cleanProperties = (obj, context, funcs) => {
        const { object, contextObject } = context;

        if (!obj) { return obj }
        let p = GetMetaProperties(obj)

        p = deleteInProperties(p, ["CreatedAt", "UpdatedAt", "DeletedAt"])

        if (funcs) {
            for (let i = 0; i < funcs.length; i++) {
                const f = funcs[i];
                p = f(p);
            }
        }

        // p = foreachInProperties(p, n => (n.type == "object"), {
        //     queryFilter: [
        //         QueryDetail("collection"),
        //         QueryOrder("ID", "ASC"),
        //     ],
        //     dropdownActions: (value, item, meta, contextObject) => {
        //         let name = item?.relation?.reference?.object;
        //         let m = meta[name]

        //         return [{
        //             title: "Создать",
        //             form: Model,

        //             object: {},

        //             meta: cleanProperties(m, {...context, contextObject: contextObject}),
        //             action: (values, unlock, close, { collection, setCollection, apply }) => {
        //                 POST(auth, `/api/query-create/${name}`, { ...values },
        //                     ({ data }) => {
        //                         setCollection(updateInArray(collection, data));
        //                         if (apply) {
        //                             apply(data);
        //                         }
        //                         close();
        //                     },
        //                     (err) => errorCatch(err, unlock)
        //                 );
        //             },
        //         },
        //         ]
        //     }
        // })

        p = foreachInProperties(p, n => (n.type == "object" && n.name == "User"), {
            mode: "dialog",
            relation: {
                uiFilter: () => [
                    {
                        name: "lastname",
                        sort: true,
                        filter: true,
                    },
                    {
                        name: "firstname",
                        sort: true,
                        filter: true,
                    },
                    {
                        name: "patronymic",
                        sort: true,
                        filter: true,
                    },

                    {
                        name: "email",
                        sort: true,
                        filter: true,
                    },
                    {
                        label: "Телефон",
                        name: "phone",
                        sort: true,
                        filter: true,
                    },
                    {
                        name: "gender",
                        sort: true,
                        filter: true,
                        display: (o) => o.name,
                    },
                    {
                        label: "Дата создания",
                        name: "createdAt",
                        type: "date",
                        sort: true,
                        filter: true,
                    },
                ],
                displayString: (item) => {
                    return item?.lastname + " " + item?.firstname
                },
                display: (item) => {
                    return (
                        <User item={item} />
                    )
                },
                reference: { object: "User", property: "ID" },
                type: "many-one",
            },
            dropdownActions: undefined,
            queryFilter: [
                QueryDetail("combobox"),
                QueryOrder("firstname", "ASC")
            ]
        })

        p = foreachInProperties(p, n => (n.type == "string" && !n?.db?.size), {
            type: "func",
            render: (auth, item, value, onChange, onAfterChange, isChanged) => {
                return (<MDEditor
                    data-color-mode="light"
                    value={value} onChange={onChange}
                    preview={"edit"}
                    overflow={false}
                />)
            }
        })

        return SetMetaProperties(obj, p)
    }

    const [razreshenieRassilok, setRazreshenieRassilok] = useState()
    useEffect(() => {
        GET(auth, "/api/config/razreshenie-rassilok",
            ({ data }) => {
                let res = {}
                for (let i = 0; i < data?.length; i++) {
                    const el = data[i];
                    res[el?.key] = el?.value
                }
                setRazreshenieRassilok(res)
            }, errorCatch
        );
    }, [])

    return (
        <PageLayout>
            <Row gutter={[5, 5]} style={{ paddingTop: "10px" }}>
                <Col span={24}>
                    <Card size="small" bordered={false}>
                        <Tabs defaultActiveKey="n1">
                            <TabPane tab="Общие" key="c0">
                                <Action
                                    auth={auth}
                                    action={(values, unlock, close) => {
                                        let href = "/api/sudifederatsii/recalc-isnotcalc-effektivnost-sudei"
                                        if (values?.recalcAll) {
                                            href = "/api/sudifederatsii/recalc-all-effektivnost-sudei"
                                        }

                                        GET(auth, href, ({ data }) => {
                                            close()
                                        }, (err) => errorCatch(err, () => unlock()))

                                    }}
                                    modal={{
                                        title: "Расчет эффективности судей"
                                    }}
                                    okText="Рассчитать"
                                    mode={"func"}

                                    form={RecalcEffectivnostForm}
                                    trigger={(click) => (
                                        <div>
                                            <Button type="link" onClick={click}>Расчет эффективности судей</Button>
                                        </div>
                                    )}
                                />
                                <div style={{display: "flex", flexDirection: "column", gap: "20px", marginTop: "20px", padding: "0 15px"}}>
                                    <div>
                                        <span style={{ paddingRight: "3px" }}>Рассылка в Telegram {(razreshenieRassilok?.tg === "denny") ? "запрещена" : "разрешена"} </span>
                                        <Button
                                            danger={(razreshenieRassilok?.tg !== "denny")}
                                            size="small"
                                            type={(razreshenieRassilok?.tg !== "denny")?"dashed":"primary"}
                                            onClick={() => {
                                                GET(auth, `/api/config/set-razreshenie-rassilok/tg/${(razreshenieRassilok?.tg === "denny") ? "allow" : "denny"}`,
                                                    ({ data }) => {
                                                        if (data && data.ID) {
                                                            setRazreshenieRassilok(o => ({ ...o, [data?.key]: data?.value }))
                                                        }
                                                    }, errorCatch
                                                );
                                            }}>{(razreshenieRassilok?.tg === "denny") ? "Разрешить" : "Запретить"}</Button>
                                    </div>
                                    <div>
                                        <span style={{ paddingRight: "3px" }}>Рассылка в ВКонтакте {(razreshenieRassilok?.vk === "denny") ? "запрещена" : "разрешена"} </span>
                                        <Button
                                            danger={(razreshenieRassilok?.vk !== "denny")}
                                            size="small"
                                            type={(razreshenieRassilok?.vk !== "denny")?"dashed":"primary"}
                                            onClick={() => {
                                                GET(auth, `/api/config/set-razreshenie-rassilok/vk/${(razreshenieRassilok?.vk === "denny") ? "allow" : "denny"}`,
                                                    ({ data }) => {
                                                        if (data && data.ID) {
                                                            setRazreshenieRassilok(o => ({ ...o, [data?.key]: data?.value }))
                                                        }
                                                    }, errorCatch
                                                );
                                            }}>{(razreshenieRassilok?.vk === "denny") ? "Разрешить" : "Запретить"}</Button>
                                    </div>
                                    <div>
                                        <span style={{ paddingRight: "3px" }}>Рассылка в Max {(razreshenieRassilok?.max === "denny") ? "запрещена" : "разрешена"} </span>
                                        <Button
                                            danger={(razreshenieRassilok?.max !== "denny")}
                                            size="small"
                                            type={(razreshenieRassilok?.max !== "denny")?"dashed":"primary"}
                                            onClick={() => {
                                                GET(auth, `/api/config/set-razreshenie-rassilok/max/${(razreshenieRassilok?.max === "denny") ? "allow" : "denny"}`,
                                                    ({ data }) => {
                                                        if (data && data.ID) {
                                                            setRazreshenieRassilok(o => ({ ...o, [data?.key]: data?.value }))
                                                        }
                                                    }, errorCatch
                                                );
                                            }}>{(razreshenieRassilok?.max === "denny") ? "Разрешить" : "Запретить"}</Button>
                                    </div>
                                </div>
                            </TabPane>
                            <TabPane key="black-list-dancer" tab={"Дисквалификация танцоров"}>
                                <CollectionServer
                                    auth={auth}
                                    name={"BlackListDancer"}
                                    queryDetail={"collection"}
                                    filters={() => filtersFromMeta("BlackListDancer")}

                                    mode="list"
                                    render={(item, idx) => (
                                        <div style={{ padding: "0px 5px" }}>
                                            <div>{getObjectDisplay(item, "BlackListDancer", meta)}</div>
                                            <div style={{ color: "#6a6a6a" }}></div>
                                        </div>
                                    )}


                                    linksModelActions={"inline"}

                                    modelActions={(item, index, { mobject, name, field, fieldName, contextObject, collection, actions }) => {
                                        return actions.map(e => ({ ...e, meta: cleanProperties(mobject, { name, field, fieldName, contextObject, object: item }) }))
                                        // return actions
                                    }}
                                    collectionActions={({ mobject, name, field, fieldName, contextObject, collection, actions }) => {
                                        return actions.map(e => ({ ...e, meta: cleanProperties(mobject, { name, field, fieldName, contextObject }) }))
                                        // return actions
                                    }}
                                />
                            </TabPane>
                            {/* <TabPane key="system-shablonisudeiskikhgonorarov" tab={"Шаблоны судейских гонораров"}>
                                <CollectionServer
                                    auth={auth}
                                    name={"ShabloniSudeiskikhGonorarov"}
                                    queryDetail={"collection"}
                                    filters={() => filtersFromMeta("ShabloniSudeiskikhGonorarov")}

                                    mode="list"
                                    render={(item, idx) => (
                                        <div style={{ padding: "0px 5px" }}>
                                            <div>{getObjectDisplay(item, "ShabloniSudeiskikhGonorarov", meta)}</div>
                                            <div style={{ color: "#6a6a6a" }}></div>
                                        </div>
                                    )}

                                    linksModelActions={"inline"}
                                    scheme={[
                                        "DetShablonaSudGonorarovShablon"
                                    ]}

                                    modelActions={(item, index, { mobject, name, field, fieldName, contextObject, collection, actions }) => {
                                        return actions.map(e => ({ ...e, meta: cleanProperties(mobject, { name, field, fieldName, contextObject, object: item }) }))
                                    }}
                                    collectionActions={({ mobject, name, field, fieldName, contextObject, collection, actions }) => {
                                        let funcs = []
                                        let ac = actions.map(e => ({ ...e, meta: cleanProperties(mobject, { name, field, fieldName, contextObject }, funcs) }))
                                        return ac
                                    }}
                                />
                            </TabPane> */}
                            {["KategoriyaNovostei"].map((e, idx) => {
                                let metaObj = meta[e];
                                if (!metaObj) {
                                    return;
                                }
                                return (<TabPane tab={metaObj.label} key={`n${idx}`}>
                                    <CollectionServer
                                        auth={auth}
                                        name={"KategoriyaNovostei"}
                                        source={`/api/query/kategoriyanovostei`}
                                        // contextFilters={() => [
                                        //     QueryParam("kategoriyaUchastnikovVSerii.seriya", object.ID)
                                        // ]}
                                        // collectionRef={cref}
                                        filters={() => filtersFromMeta(metaObj.name)}

                                        // columns={() => metaObj.properties.filter(n => {
                                        //     return n.type === "string"
                                        // }).map(n => ({
                                        //     title: n.label,
                                        //     render: (text, record) => {
                                        //         if (n.name == "ID") {
                                        //             return record[n.name]
                                        //         }
                                        //         return (record[uncapitalize(n.name)]);
                                        //     }
                                        // }))}

                                        customRender={(items, {
                                            collection,
                                            setCollection,
                                            setCollectionItem,
                                            removeCollectionItem,
                                            collectionActions,
                                            modelActions,
                                            update
                                        }) => (
                                            <table className="table" style={{ fontSize: "13px" }}>
                                                <thead>
                                                    <tr>
                                                        <th className={`wrap`} style={{ minWidth: "120px", maxWidth: "120px" }}><div className='bg bg-grey dark-1' style={{ textAlign: "left" }}>Название</div></th>
                                                        <th className={`wrap`} style={{ minWidth: "120px", maxWidth: "120px" }}><div className='bg bg-grey dark-1' style={{ textAlign: "left" }}>Описание</div></th>
                                                        <th className={`wrap`} style={{ minWidth: "25px", maxWidth: "25px", width: "25px" }}></th>
                                                    </tr>
                                                </thead>
                                                <tbody style={{ fontSize: "12px" }}>
                                                    {JSXMap(items, (item, oidx) => {
                                                        return (<tr key={oidx} >
                                                            <td className={`fill`}>
                                                                <div style={{ textAlign: "left" }}>
                                                                    {item?.nazvanie}
                                                                </div>
                                                            </td>
                                                            <td className={`fill`}>
                                                                <div style={{ textAlign: "left" }}>
                                                                    {item?.opisanie}
                                                                </div>
                                                            </td>
                                                            <td className={`fill`} style={{ minWidth: "25px", maxWidth: "25px", width: "25px" }} onClick={(e) => { e.stopPropagation() }}>
                                                                <DropdownAction
                                                                    style={{ padding: "0" }}
                                                                    button={() => (<div className={`pointer`} style={{ minWidth: "25px", maxWidth: "25px", display: "flex", height: "100%", justifyContent: "center", alignItems: "center" }}>
                                                                        <i className="fa fa-ellipsis-h"></i>
                                                                    </div>)}
                                                                    items={modelActions(item, idx)?.map((e, idx) => ({
                                                                        key: e.key || idx,
                                                                        auth: auth,
                                                                        mode: "MenuItem",
                                                                        object: item,
                                                                        collection: collection,
                                                                        setCollection: setCollection,
                                                                        ...e
                                                                    }))} />
                                                            </td>
                                                        </tr>)
                                                    })}
                                                </tbody>
                                            </table>
                                        )}
                                        size={"small"}

                                        collectionActions={() => [{
                                            auth: auth,
                                            action: (values, unlock, close, { collection, setCollection }) => POST(auth, `/api/kategoriya-novostei/create`, values, ({ data }) => {
                                                setCollection(updateInArray(collection, data));
                                                close();
                                            }, (err) => errorCatch(err, unlock)),
                                            title: "Добавить категорию новостей",
                                            form: Model,
                                            meta: () => metaObj.properties.filter(n => {
                                                return n.name !== "CreatedAt" && n.name !== "UpdatedAt" && n.name !== "DeletedAt" && n.name !== "Creator" &&
                                                    n.name !== "Dispersion" && n.name !== "Coefficient"
                                            }),
                                        }]}
                                        modelActions={(item) => [{
                                            auth: auth,
                                            title: "Изменить",
                                            modal: {

                                                title: "Изменить категорию новостей",
                                            },
                                            object: item,
                                            action: (values, unlock, close, { collection, setCollection }) => POST(auth, `/api/kategoriya-novostei/update`, { ...values, ID: item.ID },
                                                ({ data }) => {
                                                    setCollection(updateInArray(collection, data));
                                                    close();
                                                },
                                                (err) => errorCatch(err, unlock)),
                                            form: Model,
                                            meta: () => [...metaObj.properties.filter(n => {
                                                return n.name !== "CreatedAt" && n.name !== "UpdatedAt" && n.name !== "DeletedAt" && n.name !== "Creator" &&
                                                    n.name !== "Dispersion" && n.name !== "Coefficient"
                                            })],
                                        },
                                        {
                                            auth: auth,
                                            title: <span style={{ color: "red" }}>Удалить</span>,
                                            action: (values, unlock, close, { collection, setCollection }) => {
                                                confirmKey({
                                                    pass: '123',
                                                    title: <span><Icofont icon="check-circled" style={{ color: "orange" }} /> Удалить категорию новостей</span>,
                                                    icon: undefined,
                                                    content: <span>Вы действительно хотите удалить категорию новостей?</span>,
                                                    okText: 'Удалить',
                                                    cancelText: 'Отмена',
                                                    onOk() {
                                                        return new Promise((resolve, reject) => {
                                                            GET(auth, '/api/kategoriya-novostei/delete/' + item.ID,
                                                                ({ data }) => {
                                                                    setCollection(deleteInArray(collection, item));
                                                                    resolve(data);
                                                                }, (err) => errorCatch(err, reject));
                                                        }).catch(() => { });
                                                    },
                                                    onCancel() {
                                                    },
                                                })

                                            }
                                        }]}
                                    />
                                </TabPane>)
                            })}
                            <TabPane tab="Сезоны" key="k1">
                                <AbstractCollection
                                    auth={auth}
                                    name={"Sezoni"}
                                    columns={() => [
                                        {
                                            title: "Название",
                                            render: (text, record) => {
                                                return (record.nazvanie);
                                            }
                                        },
                                        {
                                            title: "Дата начала",
                                            render: (text, record) => {
                                                return (dayjs(record.dataNachala).tz("Europe/Moscow").format('DD.MM.YYYY'));
                                            }
                                        },
                                        {
                                            title: "Дата окончания",
                                            render: (text, record) => {
                                                return (dayjs(record.dataOkonchaniya).tz("Europe/Moscow").format('DD.MM.YYYY'));
                                            }
                                        }
                                    ]}
                                    form={Model}
                                    meta={() => meta["Sezoni"]?.properties.filter(n => {
                                        return n.name !== "CreatedAt" && n.name !== "UpdatedAt" && n.name !== "DeletedAt" && n.name !== "Creator"
                                    })}
                                />
                            </TabPane>

                            {["KategoriiUchastnikov", "Tantsi", "VidiTantsev", "TantsevalnieDistsiplini", "SinglParaKollektiv"].map((e, idx) => {
                                let metaObj = meta[e];
                                if (!metaObj) {
                                    return;
                                }
                                return (<TabPane tab={metaObj.label} key={idx}>
                                    <AbstractCollection
                                        auth={auth}
                                        name={metaObj.name}
                                        columns={() => metaObj.properties.filter(n => {
                                            if ((e == "KategoriiUchastnikov" || e == "TantsevalnieDistsiplini") && n.name == "ID") {
                                                return true
                                            }
                                            return n.type === "string"
                                        }).map(n => ({
                                            title: n.label,
                                            render: (text, record) => {
                                                if (n.name == "ID") {
                                                    return record[n.name]
                                                }
                                                return (record[uncapitalize(n.name)]);
                                            }
                                        }))}
                                        form={Model}
                                        meta={() => metaObj.properties.filter(n => {
                                            return n.name !== "CreatedAt" && n.name !== "UpdatedAt" && n.name !== "DeletedAt" && n.name !== "Creator"
                                        })}
                                    />
                                </TabPane>
                                )
                            })}
                            {["KategoriiTantsevalnikhDistsiplin"].map((e, idx) => {
                                let metaObj = meta[e];
                                if (!metaObj) {
                                    return;
                                }
                                return (<TabPane tab={metaObj.label} key={`kat${idx}`}>
                                    <CollectionServer
                                        auth={auth}
                                        name={"KategoriiTantsevalnikhDistsiplin"}
                                        // source={`/api/query/parenteventserii`}
                                        // contextFilters={() => [
                                        //     QueryParam("kategoriyaUchastnikovVSerii.seriya", object.ID)
                                        // ]}
                                        // collectionRef={cref}
                                        filters={() => filtersFromMeta(metaObj.name)}

                                        // columns={() => metaObj.properties.filter(n => {
                                        //     return n.type === "string"
                                        // }).map(n => ({
                                        //     title: n.label,
                                        //     render: (text, record) => {
                                        //         if (n.name == "ID") {
                                        //             return record[n.name]
                                        //         }
                                        //         return (record[uncapitalize(n.name)]);
                                        //     }
                                        // }))}

                                        customRender={(items, {
                                            collection,
                                            setCollection,
                                            setCollectionItem,
                                            removeCollectionItem,
                                            collectionActions,
                                            modelActions,
                                            update
                                        }) => (
                                            <table className="table" style={{ fontSize: "13px" }}>
                                                <thead>
                                                    <tr>
                                                        <th className={`wrap`} style={{ minWidth: "120px", maxWidth: "120px" }}><div className='bg bg-grey dark-1' style={{ textAlign: "left" }}>Танцевальная дисциплина</div></th>
                                                        <th className={`wrap`} style={{ minWidth: "120px", maxWidth: "120px" }}><div className='bg bg-grey dark-1' style={{ textAlign: "left" }}>Категория</div></th>
                                                        <th className={`wrap`} style={{ minWidth: "25px", maxWidth: "25px", width: "25px" }}></th>
                                                    </tr>
                                                </thead>
                                                <tbody style={{ fontSize: "12px" }}>
                                                    {JSXMap(items, (item, oidx) => {
                                                        return (<tr key={oidx} >
                                                            <td className={`fill`}>
                                                                <div style={{ textAlign: "left" }}>
                                                                    {item?.tantsevalnayaDistsiplina?.nazvanie}
                                                                </div>
                                                            </td>
                                                            <td className={`fill`}>
                                                                <div style={{ textAlign: "left" }}>
                                                                    {item?.kategoriya?.nazvanie}
                                                                </div>
                                                            </td>
                                                            <td className={`fill`} style={{ minWidth: "25px", maxWidth: "25px", width: "25px" }} onClick={(e) => { e.stopPropagation() }}>
                                                                <DropdownAction
                                                                    style={{ padding: "0" }}
                                                                    button={() => (<div className={`pointer`} style={{ minWidth: "25px", maxWidth: "25px", display: "flex", height: "100%", justifyContent: "center", alignItems: "center" }}>
                                                                        <i className="fa fa-ellipsis-h"></i>
                                                                    </div>)}
                                                                    items={modelActions(item, idx)?.map((e, idx) => ({
                                                                        key: e.key || idx,
                                                                        auth: auth,
                                                                        mode: "MenuItem",
                                                                        object: item,
                                                                        collection: collection,
                                                                        setCollection: setCollection,
                                                                        ...e
                                                                    }))} />
                                                            </td>
                                                        </tr>)
                                                    })}
                                                </tbody>
                                            </table>
                                        )}
                                        size={"small"}

                                        collectionActions={() => [{
                                            auth: auth,
                                            action: (values, unlock, close, { collection, setCollection }) => POST(auth, `/api/kategorii-tantsevalnikh-distsiplin/new`, values, ({ data }) => {
                                                setCollection(updateInArray(collection, data));
                                                close();
                                            }, (err) => errorCatch(err, unlock)),
                                            title: "Добавить категорию танцевальной дисциплины",
                                            form: Model,
                                            meta: () => metaObj.properties.filter(n => {
                                                return n.name !== "CreatedAt" && n.name !== "UpdatedAt" && n.name !== "DeletedAt" && n.name !== "Creator" &&
                                                    n.name !== "Dispersion" && n.name !== "Coefficient"
                                            }),
                                        }]}
                                        modelActions={(item) => [{
                                            auth: auth,
                                            title: "Изменить",
                                            modal: {
                                                width: "600px",
                                                title: "Изменить категорию танцевальной дисциплины",
                                            },
                                            object: item,
                                            action: (values, unlock, close, { collection, setCollection }) => POST(auth, `/api/kategorii-tantsevalnikh-distsiplin/update`, { ...values, ID: item.ID },
                                                ({ data }) => {
                                                    setCollection(updateInArray(collection, data));
                                                    close();
                                                },
                                                (err) => errorCatch(err, unlock)),
                                            form: Model,
                                            meta: () => [...metaObj.properties.filter(n => {
                                                return n.name !== "CreatedAt" && n.name !== "UpdatedAt" && n.name !== "DeletedAt" && n.name !== "Creator" &&
                                                    n.name !== "Dispersion" && n.name !== "Coefficient"
                                            }), {
                                                type: "func",
                                                render: (auth, _item) => {
                                                    console.log(item.dispersion, item.coefficient)
                                                    return (<div>
                                                        <div>
                                                            Дисперсия для нормального распределения: {item.dispersion}
                                                        </div>
                                                        <div>
                                                            Коэффициент для нормального распределения: {item.coefficient}
                                                        </div>
                                                    </div>)
                                                }
                                            }],
                                        },
                                        {
                                            auth: auth,
                                            title: <span style={{ color: "red" }}>Удалить</span>,
                                            action: (values, unlock, close, { collection, setCollection }) => {
                                                confirmKey({
                                                    pass: '123',
                                                    title: <span><Icofont icon="check-circled" style={{ color: "orange" }} /> Удалить категорию танцевальной дисциплины</span>,
                                                    icon: undefined,
                                                    content: <span>Вы действительно хотите удалить категорию танцевальной дисциплины?</span>,
                                                    okText: 'Удалить',
                                                    cancelText: 'Отмена',
                                                    onOk() {
                                                        return new Promise((resolve, reject) => {
                                                            GET(auth, '/api/kategorii-tantsevalnikh-distsiplin/delete/' + item.ID,
                                                                ({ data }) => {
                                                                    setCollection(deleteInArray(collection, item));
                                                                    resolve(data);
                                                                }, (err) => errorCatch(err, reject));
                                                        }).catch(() => { });
                                                    },
                                                    onCancel() {
                                                    },
                                                })

                                            }
                                        }]}
                                    />
                                </TabPane>
                                )
                            })}
                            {["PointsTemplate"].map((e, idx) => {
                                let metaObj = meta[e];
                                if (!metaObj) {
                                    return;
                                }
                                return (<TabPane tab={metaObj.label} key={`x${idx}`}>
                                    <CollectionServer
                                        auth={auth}
                                        name={"PointsTemplate"}
                                        // source={`/api/query/parenteventserii`}
                                        // contextFilters={() => [
                                        //     QueryParam("kategoriyaUchastnikovVSerii.seriya", object.ID)
                                        // ]}
                                        // collectionRef={cref}
                                        filters={() => filtersFromMeta(metaObj.name)}

                                        // columns={() => metaObj.properties.filter(n => {
                                        //     return n.type === "string"
                                        // }).map(n => ({
                                        //     title: n.label,
                                        //     render: (text, record) => {
                                        //         if (n.name == "ID") {
                                        //             return record[n.name]
                                        //         }
                                        //         return (record[uncapitalize(n.name)]);
                                        //     }
                                        // }))}

                                        customRender={(items, {
                                            collection,
                                            setCollection,
                                            setCollectionItem,
                                            removeCollectionItem,
                                            collectionActions,
                                            modelActions,
                                            update
                                        }) => (
                                            <table className="table" style={{ fontSize: "13px" }}>
                                                <thead>
                                                    <tr>
                                                        {/* <th className={`wrap`} style={{ minWidth: "25px", maxWidth: "25px", width: "25px" }}></th> */}
                                                        <th className={`wrap`} style={{ minWidth: "120px", maxWidth: "120px" }}><div className='bg bg-grey dark-1' style={{ textAlign: "left" }}>Наименование шаблона</div></th>
                                                        <th className={`wrap`} style={{ minWidth: "25px", maxWidth: "25px", width: "25px" }}></th>
                                                    </tr>
                                                </thead>
                                                <tbody style={{ fontSize: "12px" }}>
                                                    {JSXMap(items, (o, oidx) => {
                                                        return (<CRow key={oidx} auth={auth} item={o} idx={oidx} collection={collection} setCollection={setCollection} setCollectionItem={setCollectionItem} modelActions={modelActions} />)
                                                    })}
                                                </tbody>
                                            </table>
                                        )}
                                        size={"small"}

                                        collectionActions={() => [{
                                            auth: auth,
                                            action: (values, unlock, close, { collection, setCollection }) => POST(auth, `/api/points-template/new`, values, ({ data }) => {
                                                setCollection(updateInArray(collection, data));
                                                close();
                                            }, (err) => errorCatch(err, unlock)),
                                            title: "Добавить шаблон",
                                            form: Model,
                                            meta: () => metaObj.properties.filter(n => {
                                                return n.name !== "CreatedAt" && n.name !== "UpdatedAt" && n.name !== "DeletedAt" && n.name !== "Creator"
                                            }),
                                        }]}
                                        modelActions={(item) => [{
                                            auth: auth,
                                            title: "Изменить",
                                            modal: {
                                                width: "600px",
                                                title: "Изменить шаблон",
                                            },
                                            object: item,
                                            action: (values, unlock, close, { collection, setCollection }) => POST(auth, `/api/points-template/update`, { ...values, ID: item.ID },
                                                ({ data }) => {
                                                    setCollection(updateInArray(collection, data));
                                                    close();
                                                },
                                                (err) => errorCatch(err, unlock)),
                                            form: Model,
                                            meta: () => [...metaObj.properties.filter(n => {
                                                return n.name !== "CreatedAt" && n.name !== "UpdatedAt" && n.name !== "DeletedAt" && n.name !== "Creator"
                                            }), {
                                                type: "func",
                                                render: (auth, _item) => {
                                                    return (<CollectionServer
                                                        auth={auth}
                                                        name={"PointsTemplateItem"}
                                                        // source={`/api/query/pointstemplateitem`}
                                                        contextFilters={() => [
                                                            QueryParam("w-template.ID", item.ID)
                                                        ]}
                                                        // collectionRef={cref}
                                                        filters={() => [{
                                                            label: "Баллы",
                                                            name: "points",
                                                            sort: true,
                                                            filter: true,
                                                            sorted: "DESC",
                                                        },
                                                        {
                                                            label: "Место",
                                                            name: "place",
                                                            sort: true,
                                                            filter: true,
                                                        }]}
                                                        customRender={(items, {
                                                            collection,
                                                            setCollection,
                                                            setCollectionItem,
                                                            removeCollectionItem,
                                                            collectionActions,
                                                            modelActions,
                                                            update
                                                        }) => (
                                                            <table className="table" style={{ fontSize: "13px" }}>
                                                                <thead>
                                                                    <tr>
                                                                        <th className={`wrap`} style={{ minWidth: "120px", maxWidth: "120px" }}><div className='bg bg-grey dark-1' style={{ textAlign: "left" }}>Баллы</div></th>
                                                                        <th className={`wrap`} style={{ minWidth: "120px", maxWidth: "120px" }}><div className='bg bg-grey dark-1' style={{ textAlign: "left" }}>Место</div></th>
                                                                        <th className={`wrap`} style={{ minWidth: "25px", maxWidth: "25px", width: "25px" }}></th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody style={{ fontSize: "12px" }}>
                                                                    {JSXMap(items, (o, oidx) => {
                                                                        return (<tr key={idx}>
                                                                            <td className={`fill`}>
                                                                                <div className={`bg bg-grey`} style={{ textAlign: "left" }}>
                                                                                    <div>{o?.points}</div>
                                                                                </div>
                                                                            </td>
                                                                            <td className={`fill`}>
                                                                                <div className={`bg bg-grey`} style={{ textAlign: "left" }}>
                                                                                    <div>{o?.place}</div>
                                                                                </div>
                                                                            </td>
                                                                            <td className={`fill`} onClick={(e) => { e.stopPropagation() }}>
                                                                                <DropdownAction
                                                                                    style={{ padding: "0" }}
                                                                                    button={() => (<div className={`bg bg-grey pointer`} style={{ minWidth: "25px", maxWidth: "25px", display: "flex", height: "100%", justifyContent: "center", alignItems: "center" }}>
                                                                                        <i className="fa fa-ellipsis-h"></i>
                                                                                    </div>)}
                                                                                    items={modelActions(o, idx)?.map((e, idx) => ({
                                                                                        key: e.key || idx,
                                                                                        auth: auth,
                                                                                        mode: "MenuItem",
                                                                                        object: o,
                                                                                        collection: collection,
                                                                                        setCollection: setCollection,
                                                                                        ...e
                                                                                    }))} />
                                                                            </td>
                                                                        </tr>)
                                                                    })}
                                                                </tbody>
                                                            </table>
                                                        )}
                                                        size={"small"}
                                                        collectionActions={() => [{
                                                            auth: auth,
                                                            action: (values, unlock, close, { collection, setCollection }) => POST(auth, `/api/points-template-item/new`, { ...values, templateID: item?.ID }, ({ data }) => {
                                                                setCollection(updateInArray(collection, data));
                                                                close();
                                                            }, (err) => errorCatch(err, unlock)),
                                                            title: "Добавить элемент",
                                                            form: Model,
                                                            meta: () => meta["PointsTemplateItem"]?.properties?.filter(n => {
                                                                return n.name == "Points" || n.name == "Place"
                                                            }),
                                                        }]}
                                                        modelActions={(item) => [{
                                                            title: "Изменить",
                                                            modal: {
                                                                width: "600px",
                                                                title: "Изменить серию",
                                                            },
                                                            object: item,
                                                            action: (values, unlock, close, { collection, setCollection }) => {
                                                                POST(auth, `/api/points-template-item/update`, { ...values, templateID: item?.templateID, ID: item?.ID },
                                                                    ({ data }) => {
                                                                        setCollection(updateInArray(collection, data));
                                                                        close();
                                                                    },
                                                                    (err) => errorCatch(err, unlock));
                                                            },
                                                            form: Model,
                                                            meta: () => meta["PointsTemplateItem"]?.properties?.filter(n => {
                                                                return n.name == "Points" || n.name == "Place"
                                                            }),
                                                        },
                                                        {
                                                            auth: auth,
                                                            title: <span style={{ color: "red" }}>Удалить</span>,
                                                            action: (values, unlock, close, { collection, setCollection }) => {
                                                                confirmKey({
                                                                    pass: '123',
                                                                    title: <span><Icofont icon="check-circled" style={{ color: "orange" }} /> Удалить элемент</span>,
                                                                    icon: undefined,
                                                                    content: <span>Вы действительно хотите удалить элемент?</span>,
                                                                    okText: 'Удалить',
                                                                    cancelText: 'Отмена',
                                                                    onOk() {
                                                                        return new Promise((resolve, reject) => {
                                                                            GET(auth, '/api/points-template-item/delete/' + item.ID,
                                                                                ({ data }) => {
                                                                                    setCollection(deleteInArray(collection, item));
                                                                                    resolve(data);
                                                                                }, (err) => errorCatch(err, reject));
                                                                        }).catch(() => { });
                                                                    },
                                                                    onCancel() {
                                                                    },
                                                                })

                                                            }
                                                        }]}
                                                    />)
                                                }
                                            }],
                                        },
                                        {
                                            auth: auth,
                                            title: <span style={{ color: "red" }}>Удалить</span>,
                                            action: (values, unlock, close, { collection, setCollection }) => {
                                                confirmKey({
                                                    pass: '123',
                                                    title: <span><Icofont icon="check-circled" style={{ color: "orange" }} /> Удалить шаблон</span>,
                                                    icon: undefined,
                                                    content: <span>Вы действительно хотите удалить шаблон?</span>,
                                                    okText: 'Удалить',
                                                    cancelText: 'Отмена',
                                                    onOk() {
                                                        return new Promise((resolve, reject) => {
                                                            GET(auth, '/api/points-template/delete/' + item.ID,
                                                                ({ data }) => {
                                                                    setCollection(deleteInArray(collection, item));
                                                                    resolve(data);
                                                                }, (err) => errorCatch(err, reject));
                                                        }).catch(() => { });
                                                    },
                                                    onCancel() {
                                                    },
                                                })

                                            }
                                        }]}
                                    />
                                </TabPane>
                                )
                            })}


                        </Tabs>
                    </Card>
                </Col>
            </Row>
        </PageLayout>
    );
}